import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import { withTranslation } from "../../../i18n/translate"
import ClearFilterIcon from "../../../images/icons/clear.svg"
import FilterIcon from "../../../images/icons/filter.svg"
import Button from "../../button/button"
import SplitLayout from "../../layout/split-layout"
import PageHeader from "../../page-header/page-header"
import SEO from "../../seo"
import { WalkThroughTooltip } from "../../walk-through-tooltip/walk-through-tooltip"
import ProductFilters from "../product-filters/product-filters"
import ProductTableList from "./product-table-list"
import "./product-view.sass"

class ProductView extends React.Component {
  constructor(props) {
    super(props)
    this.db = props.db
    this.filterKey = props.filterKey

    if (this.filterKey) {
      this.db.restoreState(this.props.getFilter(this.filterKey))
    }

    const searchParams = new URLSearchParams(props.location.search)
    this.db.loadSearchParams(searchParams)

    this.state = {
      hasFilters: false,
    }

    // Exceptions
    if (props.title) {
      throw new Error('"title" prop is deprecated')
    }
    //
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        hasFilters: this.db.hasFilters(),
        initialStateRestored: this.db.isInitialStateRestored(),
      })
    })

    this.dbSub = this.db.onUpdate(() => {
      if (this.filterKey) {
        this.props.saveFilters(this.db.getState(), this.filterKey)
      }

      this.setState({
        hasFilters: this.db.hasFilters(),
        initialStateRestored:
          this.state.initialStateRestored && this.db.hasFilters(),
      })
    })
  }

  componentWillUnmount() {
    if (this.filterKey) {
      this.props.saveFilters(this.db.getState(), this.filterKey)
    }
    this.dbSub.unsubscribe()
  }

  render() {
    const {
      titleTranslatedString,
      productParamGroups,
      descriptionTranslatedString,
        path
    } = this.props
    const { t } = this.props

    return (
      <SplitLayout
        header={
          <PageHeader
            levelOneTitle={t("PRODUCTS-META_TITLE")}
            levelTwoTitle={titleTranslatedString}
            levelThreeTitle={titleTranslatedString}
          />
        }
        sidebarTitleTranslationKey={"PRODUCTS-PRODUCT_FILTERS"}
        sidebar={<ProductFilters productsDatabase={this.db} />}
        scrollSynced={true}
        mobileHeader={({ toggleSidebar }) => {
          return (
            <div className="_fp-global-container">
              <div className="_fp-product-view__header">
                <WalkThroughTooltip
                  shown={this.state.initialStateRestored}
                  message={t("PRODUCTS-PRODUCT_FILTERS-FILTERS-RESTORED")}
                >
                  <Button
                    buttonCallback={toggleSidebar}
                    buttonSize={"small"}
                    buttonStyle={"green-ghost"}
                    buttonLabel={t("PRODUCTS-PRODUCT_FILTERS")}
                    buttonSvgIconComponent={<FilterIcon />}
                  />
                </WalkThroughTooltip>
                <Button
                  buttonCallback={() => this.db.resetFilters()}
                  buttonSize={"small"}
                  buttonSvgIconComponent={<ClearFilterIcon />}
                  buttonStyle={this.state.hasFilters ? "blue-soft" : "disabled"}
                  buttonLabel={t("PRODUCTS-PRODUCT_FILTERS-RESET_ALL_FILTERS")}
                />
              </div>
            </div>
          )
        }}
      >
        <SEO
          pathName={this.props.location.pathname}
          descriptionTranslatedString={descriptionTranslatedString}
          titleTranslatedString={titleTranslatedString}
        />

        <ProductTableList
          filterKey={this.filterKey}
          db={this.db}
          productParamGroups={productParamGroups}
          path={path}
        />
      </SplitLayout>
    )
  }
}

ProductView.propTypes = {
  titleTranslatedString: PropTypes.string,
  descriptionTranslatedString: PropTypes.string,
  productParamGroups: PropTypes.any,
  filterKey: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    getFilter: (key) => {
      return state.filters[key] || []
    },
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveFilters: (filters, key) =>
      dispatch({ type: "ADD_FILTER_STATE", key: key, value: filters }),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(ProductView))
